import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type GlobalStatusDisplay = 'idle' | 'loading' | 'error';

type GlobalStatusState = {
  pendingCount: number;
  /** Any HTTP failure while the batch was in flight */
  hasRecentFailure: boolean;
  /** Shown when last request ended with failure and pendingCount is 0 */
  errorFlash: boolean;
};

const initialState: GlobalStatusState = {
  pendingCount: 0,
  hasRecentFailure: false,
  errorFlash: false,
};

const globalStatusSlice = createSlice({
  name: 'globalStatus',
  initialState,
  reducers: {
    globalRequestStart(state) {
      state.pendingCount += 1;
      state.errorFlash = false;
    },
    globalRequestComplete(state, action: PayloadAction<{ success: boolean }>) {
      state.pendingCount = Math.max(0, state.pendingCount - 1);
      if (!action.payload.success) {
        state.hasRecentFailure = true;
      }
      if (state.pendingCount === 0) {
        state.errorFlash = state.hasRecentFailure;
        state.hasRecentFailure = false;
      }
    },
    clearGlobalStatusError(state) {
      state.errorFlash = false;
    },
  },
});

export const { globalRequestStart, globalRequestComplete, clearGlobalStatusError } = globalStatusSlice.actions;

export function selectGlobalStatusDisplay(state: { globalStatus: GlobalStatusState }): GlobalStatusDisplay {
  const { pendingCount, errorFlash } = state.globalStatus;
  if (pendingCount > 0) return 'loading';
  if (errorFlash) return 'error';
  return 'idle';
}

export default globalStatusSlice.reducer;
